import { PageHeader, QueryState } from "@nymbl/nos2-rules";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { DemandTable } from "@/components/guidance/DemandTable";
import { GuidanceCards } from "@/components/guidance/GuidanceCards";
import { MonthSwitcher } from "@/components/month/MonthSwitcher";
import { useMonthDemands, useMonthSummary } from "@/hooks/use-month";
import { monthRow } from "@/lib/month/metrics";
import { browserTimeZone, currentMonthKey, type MonthKey, monthLabel } from "@/lib/month/month";

export function GuidanceScreen() {
  const search = useSearch({ from: "/dashboard/guidance" });
  const navigate = useNavigate({ from: "/dashboard/guidance" });
  const current = currentMonthKey(new Date(), browserTimeZone());
  const month = search.month ?? current;
  const summary = useMonthSummary(month, 1);
  const demands = useMonthDemands(month);
  const row = monthRow(summary.data, month, summary.isPlaceholderData);

  function setMonth(next: MonthKey) {
    void navigate({ search: { month: next === current ? undefined : next } });
  }

  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Guidance"
        period={
          <MonthSwitcher
            month={month}
            current={current}
            min={summary.data?.firstMonth ?? null}
            max={summary.data?.lastMonth ?? null}
            onChange={setMonth}
          />
        }
      />
      <QueryState query={summary} skeletonClassName="h-24">
        {() => <GuidanceCards row={row} />}
      </QueryState>
      <DemandTable query={demands} monthLabel={monthLabel(month)} />
    </div>
  );
}
